import { ax } from 'src/client'
import {
  EDIT_CREATE_PARTNER_BANK_ACCOUNT,
  PARTNERS_URL,
  PARTNER_BANK_ACCOUNTS,
  PARTNER_DETAILS,
  UPDATE_PARTNER
} from './serviceURLS'

// Hardcoded limit to get all partners
export function getPartners({ limit = 999, offset = 0 } = {}) {
  return ax.get(PARTNERS_URL, {
    params: {
      limit,
      offset,
      sort_by: 'name',
      descending: false
    }
  })
}

export function getPartnerDetails(partnerId) {
  return ax.get(PARTNER_DETAILS.replace(':id', partnerId))
}

export function getPartnerBankDetails(partnerId) {
  return ax.get(PARTNER_BANK_ACCOUNTS.replace(':partner_id', partnerId))
}

export function createAndUpdatePartnerBankDetail(body) {
  return ax.post(EDIT_CREATE_PARTNER_BANK_ACCOUNT, body)
}

export function updatePartner(partnerId, body) {
  return ax.patch(UPDATE_PARTNER.replace(':partner_id', partnerId), body)
}
